var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inline-block"},[_c('div',{staticClass:"image-container"},[_vm._t("default"),_vm._v(" "),(_vm.show)?_c('div',{staticClass:"after"},[_c('div',{staticClass:"flex content-center justify-center flex-col h-full"},[_c('div',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.text))])])]):_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }